__turbopack_context__.v({
  "className": "barlow_condensed_4f23234-module__zKqFgq__className",
});
